import React from "react";
import Layout from "../../components/Layout";
import TwoColumns from "../../components/TwoColumns";
import RTF from "../../components/RTF";
import * as S from "./styles";

const Contact = ({ title, body }) => {
  return (
    <Layout>
      <TwoColumns>
        <S.Title>{title}</S.Title>
        <RTF dangerouslySetInnerHTML={{ __html: body }} />
      </TwoColumns>
    </Layout>
  );
};

export default Contact;
